module.exports = __webpack_public_path__ + "static/media/img-payment-logo.fb6204c9.svg";